var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(_vm.left != null)?_c('span',{staticClass:"left-value"},[_vm._v(_vm._s(_vm.left))]):_vm._e(),_c('div',{class:{
      'bx-complementary-bar': !_vm.more,
      'bx-complementary-bar-more': _vm.more
    }},[_c('div',{staticClass:"bx-bar",style:(("width: " + _vm.percent + "%"))})]),(_vm.right != null)?_c('span',{staticClass:"right-value"},[_vm._v(_vm._s(_vm.right))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }